<template>
  <div class="map-social">
    <a href="https://www.facebook.com/GUCCI/" target="_blank" @click="track('Facebook')" class="icon-social"><facebookIcon></facebookIcon></a>
    <a href="https://www.instagram.com/gucci/" class="icon-social" target="_blank" @click="track('Instagram')"><instagramIcon></instagramIcon></a>
    <!--<a href="https://twitter.com/gucci" class="mr-2 icon-social" target="_blank" @click="track('Twitter')"><twitterIcon></twitterIcon></a>-->
  </div>
</template>

<script>
import facebookIcon from '@/assets/svg/social/facebook.svg'
import instagramIcon from '@/assets/svg/social/instagram.svg'
// import twitterIcon from '@/assets/svg/social/twitter.svg'

export default {
  name: 'MapSocial',
  components: {
    facebookIcon,
    instagramIcon
    // twitterIcon
  },

  methods: {
    track (social) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'generic_event',
          eventCategory: 'Footer',
          eventAction: social,
          eventLabel: ''
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map-social {
  pointer-events: all;
  height: 30px;
  display: inline-block;
  vertical-align: middle;

  @include breakpoint ('xs-only') {
    height: 24px;
  }
}

.icon-social {
  display: inline-block;
  width: 30px;
  height: 30px;
  transition: all 0.25s $ease-out-quint;

  @include breakpoint ('xs-only') {
    width: 28px;
    height: 28px;
  }

  &:hover {
    path {
      fill: $c-pink;
    }
  }

  svg {
    width: 100%;
    height: 100%;

    path {
      transition: all 0.2s ease-in-out;
    }
  }
}
</style>
